import * as API from "@/services/API";

export default {
    // Send notification to all users
    broadcastToAll({ title, message }) {
        return API.apiClient.post("/admin-dashboard/broadcast-to-all", { title, message });
    },

    // Send notification to a specific user
    sendToUser({ user_id, title, message }) {
        return API.apiClient.post("/admin-dashboard/send-to-user", { user_id, title, message });
    },

    // Send notification to a group
    sendToGroup({ role_id, school_id, title, message }) {
        return API.apiClient.post("/admin-dashboard/send-to-group", { role_id, school_id, title, message });
    },

    getusers({ role_id, search } = {}) {
        return API.apiClient.get("/users/all", { params: { role_id, search } });
    }
};
